<script setup>

import SKUHistory from "@/components/warehouse/SKUHistory";
import {inject, ref, computed, onMounted} from 'vue';
import API from "@/classes/global/API";

const skuHistory = inject('skuHistory');

onMounted(() => {

  window.addEventListener("resize", getGridHeight);

  getStockMetaData();

})

let screenWidth = ref(undefined);

function getGridHeight() {

  screenWidth.value = window.innerWidth;
}

async function getStockMetaData() {

  const response = await API.getStockMetaData(null);

  if(response) skuHistory.value.skuGroups = response.skuGroups
}
</script>

<template>
<SKUHistory v-model="screenWidth"></SKUHistory>
</template>

<style scoped>

</style>
